export enum VerifyEmailParams {
    Code = 'VerificationCodeId'
}
